import { render } from "./Matricula.vue?vue&type=template&id=7dc8c401&scoped=true"
import script from "./Matricula.vue?vue&type=script&lang=js"
export * from "./Matricula.vue?vue&type=script&lang=js"

import "./Matricula.vue?vue&type=style&index=0&id=7dc8c401&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc8c401"]])

export default __exports__